import React from 'react';
import { ClassAssembly8D2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly8D2026/>;
  };
  
  export default ClassAssemblyPage;